import * as angular from "angular";
import {IController} from "angular";
import * as _ from 'lodash';

export class PlanningServicesTotalsCtrl implements IController {
  static $inject = ['$filter'];

  selectedJobs: any;

  public selectedJobsPackages: any;
  public totalJobs: { length: number } = { length: 0 };
  public totalSpots: number | string = 0;
  public totalPackages: number | string = 0;
  public totalWeight: number | string = 0;
  public totalVolume: number | string = 0;
  public totalPallets: number | string = 0;

  constructor(private $filter: any) {
  }

  $onInit() {
    this.calculateTotals();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.selectedJobs) {
      this.calculateTotals();
    }
  }

  private calculateTotals() {
    this.totalJobs = { length: this.selectedJobs ? this.selectedJobs.length : 0 };
    this.selectedJobsPackages = _.flatMap(this.selectedJobs, 'packages');
    this.totalSpots = this.$filter('orderSpots')(this.selectedJobsPackages);
    this.totalPackages = this.$filter('servicePackagesCount')(this.selectedJobsPackages);
    this.totalWeight = this.$filter('jobPackagesWeight')(this.selectedJobsPackages, true);
    this.totalVolume = this.$filter('jobPackagesVolume')(this.selectedJobsPackages, true);
    this.totalPallets = this.$filter('jobPackagesPallets')(this.selectedJobsPackages, true);
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningServicesTotals', {
    bindings: {
      selectedJobs: '<?',
    },
    template: require('./planning-services-totals.html').default,
    controller: PlanningServicesTotalsCtrl
  });
